export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/68aK2y5YLcYnBbPMK9XUXJ/ChatGPT-Image-17-jul-2026_-01_05_11-p.m..webp'

export const CHECKOUT_URL =
  'https://occupational-therapist-pro.impultienda.ar/checkout'

export const PRODUCT_NAME = 'OCCUPATIONAL THERAPIST PRO™'
